import type { PrescriptionGapPolicy } from 'types/prescription';

export const TEST_ID = 'gapPolicyToggle';

export const GAP_POLICY_MASK: PrescriptionGapPolicy = 'MASK';

export const GAP_POLICY_BASE_RATE: PrescriptionGapPolicy = 'BASE_RATE';

export const MASK_OPTION_TEST_ID = 'gapPolicyToggleMask';

export const BASE_RATE_OPTION_TEST_ID = 'gapPolicyToggleBaseRate';
